/*
 * @Author: rossdong rossdong@yntengyun.com
 * @Date: 2026-03-23 16:46:35
 * @LastEditors: rossdong rossdong@yntengyun.com
 * @LastEditTime: 2026-03-23 17:12:57
 * @FilePath: /Mobile/src/pages/complaint/views/visual/mixins/visualFilterMixin.js
 * @Description:
 * 可视化仪表盘全局筛选 Mixin
 * 用于简化子组件对筛选参数的接收与监听
 */

import { mapState } from 'vuex';
import { debounce } from 'lodash';

export default {
  data() {
    return {
      // 用于在 Mixin 层级进行防抖控制
      _visualFilterTimer: null
    };
  },
  computed: {
    ...mapState('complaint', {
      filterParams: (state) => state.visualFilter
    })
  },
  watch: {
    // 监听全局筛选参数的变化
    filterParams: {
      deep: true,
      immediate: true, // 确保挂载时立即执行一次完成初始加载
      handler(newVal, oldVal) {
        // 1. 值相等性检查（深度比较）
        if (oldVal && JSON.stringify(newVal) === JSON.stringify(oldVal)) {
          return;
        }

        // 2. 微任务防抖：防止由于父子组件声明周期冲突导致的瞬间多次触发
        if (this._visualFilterTimer) {
          clearTimeout(this._visualFilterTimer);
        }

        this._visualFilterTimer = setTimeout(() => {
          // 自动触发数据刷新：子组件通常实现 onLoad，页面组件通常实现 init
          if (typeof this.onLoad === 'function') {
            this.onLoad();
          } else if (typeof this.init === 'function') {
            this.init();
          }
          this._visualFilterTimer = null;
        }, 50); // 50ms 的防抖窗口足以拦截初始化阶段的冲突
      }
    }
  }
};
